module.exports = __webpack_public_path__ + "img/bg-ftr.ca84f54f.jpg";